export default [
  { icon: 'smart-home', title: 'DASHBOARD', link: '/', routerLinkExact: true }
];